import * as React from 'react';
import { translate } from '@data/translations';
import { Reservation, ReservationController } from './resController';
import { ReservationModel, ReservationInvoicedStatus, ReservationStatus } from '@common/modelDefinition';
import MiniLoader from '@components/loaders/miniLoader';
import ReservationGuestReference from './reservations/reservationGuestReference';
import ReservationNotifications from './reservations/reservationNotifications';
import MainReservationInfo from './reservations/mainReservationInfo';
import MinibarConsumption from './reservations/minibarConsumption';
import SelfCheckIn from './reservations/selfCheckIn';
import { ReactComponent as ChevronDown } from '../../assets/custom/icons/chevron_down.svg';
import { ReactComponent as Bell } from '../../assets/custom/icons/bell.svg';
import { ReactComponent as Edit } from '../../assets/custom/icons/edit.svg';
import { ReactComponent as Change } from '../../assets/custom/icons/change.svg';
import { ReactComponent as DeleteIcon } from '../../assets/custom/icons/trash.svg';
import { ReactComponent as Info } from '../../assets/custom/icons/info.svg';
import CondoOwnerRestrictionWrapper from './CondoOwnerRestrictionWrapper';
import { closeModal, setModalContent } from '@components/modal';
import FolderBox from '@components/documentTools/folderBox';
import ShowAvailableRoomsForReservationModal from './reservations/ChangeRoomModal';
import { reservationStatusEnumsDesc } from '@data/reservationStatusEnums';
import ConfirmButtons from '@components/buttons/confirmButtons';
import InlineModal from '@components/modalInline';
import HouseholdTask from './reservations/householdTask';
import useStore from '@data/state/zustand';
import ResRoomAccessCodes from './reservations/resRoomAccessCodes';
import ProxyRoomAccessCodes from './reservations/proxyRoomAccessCodes';

interface TabsBodyProps {
    history: any;
    loading: boolean;
    setLoading: Function;
    showReservationDetails?: Function;
}

const ReservationLinkTabs: any = {
    0: 'General',
    1: 'Guest info',
    2: 'Minibar',
    3: 'Acc. codes',
    4: 'Self check in',
    5: 'Household',
};

enum ReservationLinkTabsEnum {
    'general' = 0,
    'guestInfo' = 1,
    'minibar' = 2,
    'accessCodes' = 3,
    'selfCheckIn' = 4,
    'household' = 5,
}

function TabsBody(props: TabsBodyProps) {
    const { history, showReservationDetails } = props;
    const [activeTab, setActiveTab] = React.useState(0);
    const [showNoteModal, setShowNoteModal] = React.useState(false as boolean);
    const [showMoreOptions, setShowMoreOptions] = React.useState(false as boolean);

    const ctrl = new ReservationController();

    const reservations: Reservation[] = useStore((appState: any) => appState.state.reservationForm2.reservations);
    const otherSettings: any = useStore((appState: any) => appState.otherSettings);
    const enableUsingHologicWithBMS: any = useStore((appState: any) => appState.enableUsingHologicWithBMS);

    const reservation = ctrl.getActiveReservation();
    const groupRes = ctrl.getGroupReservation();

    const onFolderUpdated = async (documents: any) => {
        const res = { ...reservation };
        res.documents = documents;
        ctrl.updateActiveReservation(res as ReservationModel);
    };

    if (!reservation || !reservation.RoomInfo) {
        return <MiniLoader />;
    }

    // const style = loading ? { opacity: '0.4' } : {};
    // const unEditable = loading ? 'unEditable' : '';
    let isGroupInvoiceIssued = false;
    if (groupRes && groupRes.invoicedStatus !== ReservationInvoicedStatus.notPaid) {
        isGroupInvoiceIssued = true;
    }

    return (
        <>
            <CondoOwnerRestrictionWrapper history={history} reservation={reservation}>
                <div className="reservation-body-wrapper mt-2p mb-8p">
                    <InlineModal
                        show={showNoteModal}
                        header={translate('Add document')}
                        width="md"
                        setShow={setShowNoteModal}
                    >
                        {showNoteModal ? (
                            <div>
                                <FolderBox onFolderUpdated={onFolderUpdated} {...reservation} />
                            </div>
                        ) : null}
                    </InlineModal>

                    <div className="flex-center flex-column pr-8p pl-8p">
                        <div className="flex-center-between mb-8p w-100">
                            <div className="display-flex" style={{ flexDirection: 'column' }}>
                                <div className="reservation-room">
                                    {translate('Room')} {reservation?.RoomInfo?.name} (
                                    {translate(reservationStatusEnumsDesc[reservation.statusEnum])})
                                </div>
                                <div className="mt-4p text-bold color-warning">
                                {reservation?.providerReservation ? reservation?.channelName ? reservation.channelName : translate('Provider reservation')
                                        : reservation?.onlineReceptionResId
                                        ? translate('Web reservation')
                                        : ''}
                                </div>
                            </div>
                            <div className="display-flex">
                                {((groupRes && groupRes?.Reservations) || reservation?.id) && (
                                    <div>
                                        <div
                                            className="button-info mr-4p pointer pb-8p"
                                            onClick={() => {
                                                if (groupRes && groupRes.uuid) {
                                                    history.push('/issueGroupInvoice/' + groupRes.uuid);
                                                } else {
                                                    const reservation = ctrl.getReservations()[0];
                                                    history.push('/checkoutAndInvoice/' + reservation.id);
                                                }
                                            }}
                                        >
                                            {/* <i className="fa fa-print" />  */}
                                            {translate('Invoices')}
                                        </div>
                                    </div>
                                )}

                                <div
                                    className="mr-4p pointer"
                                    onClick={() => {
                                        setModalContent(
                                            <ReservationNotifications history={history} reservation={reservation} />,
                                            translate('Reservation notifications'),
                                            false,
                                            'modal-xl'
                                        );
                                    }}
                                >
                                    <Bell />
                                </div>
                                {reservation?.id && showReservationDetails ? (
                                    <div
                                        className="mr-4p pointer"
                                        onClick={() => {
                                            if (showReservationDetails && reservation?.id) {
                                                showReservationDetails(reservation?.id);
                                            }
                                        }}
                                    >
                                        <Info />
                                    </div>
                                ) : null}
                                <div className="pointer" onClick={() => setShowMoreOptions(!showMoreOptions)}>
                                    <ChevronDown />
                                    {showMoreOptions ? (
                                        <div className="more-options-wrapper shadow-sm">
                                            <div
                                                className="more-options"
                                                onClick={() => {
                                                    setShowNoteModal(true);
                                                }}
                                            >
                                                <div className=" mr-8p">
                                                    <Edit />
                                                </div>
                                                <div>{translate('Add document')}</div>
                                            </div>
                                            <div
                                                className="more-options"
                                                onClick={() => {
                                                    setModalContent(
                                                        <ShowAvailableRoomsForReservationModal
                                                            reservation={{ ...reservation }}
                                                        />,
                                                        translate('Confirm') + ' ' + translate('change room'),
                                                        false,
                                                        'modal-lg'
                                                    );
                                                }}
                                            >
                                                <div className=" mr-8p">
                                                    <Change />
                                                </div>
                                                <div>{translate('Change room')}</div>
                                            </div>
                                            <hr
                                                style={{
                                                    width: '90%',
                                                    paddingRight: '5px',
                                                    paddingLeft: '5px',
                                                    borderTop: '1px solid lightgray',
                                                    marginTop: '5px',
                                                    marginBottom: '5px',
                                                }}
                                            />
                                            {reservation.groupUuid &&
                                            reservation.id &&
                                            !isGroupInvoiceIssued &&
                                            !reservation.providerReservation ? (
                                                <div
                                                    className="more-options color-error"
                                                    onClick={() =>
                                                        setModalContent(
                                                            <div className="container-fluid">
                                                                <div className="text-center">
                                                                    {translate(
                                                                        'Do you really want to remove this reservation from group? Please confirm and reservation will become standalone!'
                                                                    )}
                                                                    <hr />
                                                                </div>
                                                                <div className="text-center">
                                                                    <ConfirmButtons
                                                                        onConfirm={async () => {
                                                                            await ctrl.removeFromGroupRes();
                                                                            closeModal();
                                                                        }}
                                                                        onCancel={() => {
                                                                            closeModal();
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>,
                                                            translate('Remove from group'), // header
                                                            false, // showCloseButton
                                                            'modal-md'
                                                        )
                                                    }
                                                >
                                                    <div className=" mr-8p fill-red">
                                                        <DeleteIcon />
                                                    </div>
                                                    <div>{translate('Remove from group')}</div>
                                                </div>
                                            ) : reservation.id &&
                                              !reservation.groupUuid &&
                                              !reservation.previousGroupUuid &&
                                              !reservation.providerReservation &&
                                              ![4, 5].includes(reservation.statusEnum) ? (
                                                <div
                                                    className="more-options color-error"
                                                    onClick={() =>
                                                        history.push('/groupInfos?reservationId=' + reservation.id)
                                                    }
                                                >
                                                    <div className=" mr-8p fill-red">
                                                        <svg width="32" height="32"></svg>
                                                    </div>
                                                    <div>{translate('Attach to group')}</div>
                                                </div>
                                            ) : null}
                                            {reservation.groupUuid &&
                                            reservation.id &&
                                            reservations?.every((r) => r.statusEnum === 1 && !isGroupInvoiceIssued) &&
                                            reservations?.every((r) => !r.providerReservation) ? (
                                                <div
                                                    className="more-options color-error"
                                                    onClick={() =>
                                                        setModalContent(
                                                            <div className="container-fluid">
                                                                <div className="text-center">
                                                                    {translate(
                                                                        'Do you really want to cancel all this reservations?'
                                                                    )}
                                                                    <hr />
                                                                </div>
                                                                <div className="text-center">
                                                                    <ConfirmButtons
                                                                        onConfirm={async () => {
                                                                            for (
                                                                                let i = 0;
                                                                                i < reservations?.length;
                                                                                i++
                                                                            ) {
                                                                                if (reservations[i]) {
                                                                                    ctrl.setActiveReservationIndex(i);
                                                                                    let res = { ...reservations[i] };
                                                                                    res.statusEnum =
                                                                                        ReservationStatus.canceled;
                                                                                    ctrl.updateActiveReservation(
                                                                                        res as ReservationModel
                                                                                    );
                                                                                }
                                                                            }
                                                                            closeModal();
                                                                        }}
                                                                        onCancel={() => {
                                                                            closeModal();
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>,
                                                            translate('Cancel all reservations'), // header
                                                            false, // showCloseButton
                                                            'modal-md'
                                                        )
                                                    }
                                                >
                                                    <div className=" mr-8p fill-red">
                                                        <svg width="32" height="32"></svg>
                                                    </div>
                                                    <div>{translate('Cancel all reservations')}</div>
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="reservation-form-tabs pl-8p pr-8p">
                        {Object.keys(ReservationLinkTabs)?.map((t: string, index: number) => {
                            return (
                                <div
                                    onClick={() => {
                                        if (reservation?.id) {
                                            setActiveTab(index);
                                        }
                                    }}
                                    className={
                                        ' reservation-form-tabs-single ' + (activeTab === index ? ' active-tab ' : '')
                                    }
                                    style={{
                                        color: reservation?.id ? (activeTab === index ? ' #0545a6' : 'black') : '',
                                    }}
                                    key={index}
                                >
                                    {translate(ReservationLinkTabs[t])}
                                </div>
                            );
                        })}
                    </div>

                    <div className="reservation-body-inner-wrapper">
                        {activeTab === ReservationLinkTabsEnum.general ? (
                            <MainReservationInfo history={history} otherSettings={otherSettings} />
                        ) : null}

                        {activeTab === ReservationLinkTabsEnum.guestInfo && reservation?.id !== undefined ? (
                            <ReservationGuestReference
                                history={history}
                                reservation={reservation}
                                otherSettings={otherSettings}
                            />
                        ) : null}

                        {activeTab === ReservationLinkTabsEnum.minibar && reservation?.id !== undefined ? (
                            <MinibarConsumption history={history} reservation={reservation} />
                        ) : null}

                        {activeTab === ReservationLinkTabsEnum.accessCodes && reservation?.id !== undefined ? (
                            enableUsingHologicWithBMS && enableUsingHologicWithBMS === 'true' ? (
                                <ResRoomAccessCodes history={history} reservation={reservation} />
                            ) : reservation?.RoomInfo?.remoteDeviceId === null ? (
                                <div className="" style={{ height: '356px' }}>
                                    <div className="mt-4p">{translate('No connected controllers')}</div>
                                </div>
                            ) : (
                                <ProxyRoomAccessCodes history={history} reservation={reservation} />
                            )
                        ) : null}

                        {activeTab === ReservationLinkTabsEnum.selfCheckIn && reservation?.id !== undefined ? (
                            <SelfCheckIn />
                        ) : null}

                        {activeTab === ReservationLinkTabsEnum.household && reservation?.id !== undefined ? (
                            <HouseholdTask history={history} reservation={reservation} />
                        ) : null}
                    </div>
                </div>
            </CondoOwnerRestrictionWrapper>
        </>
    );
}

export default TabsBody;
